import React from 'react'

import MenuIcon from '@mui/icons-material/Menu'
import { AppBar, Box, Button, IconButton, Toolbar, Typography } from '@mui/material'
import { lighten } from '@mui/material/styles'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import type { RootState } from 'reducers'

import { logout } from 'actions/auth-actions'
import { withRouter } from 'utils/withRouter'

import logo from '../static/alba.svg'
import { styles } from './coreLayoutStyles'

type CoreLayoutHeaderProps = {
  drawer: boolean
  logout: (...args: any[]) => any
  navigate: (...args: any[]) => any
  open: boolean
  onDrawerOpen: (...args: any[]) => any
  authenticated?: boolean
}

const CoreLayoutHeader = ({ authenticated, drawer, logout, navigate, open, onDrawerOpen }: CoreLayoutHeaderProps) => {
  const handleLogout = () => {
    logout()
    navigate('/')
  }

  const authButton = authenticated ? (
    <Button color="inherit" onClick={handleLogout} sx={{ mr: 2 }}>
      Logout
    </Button>
  ) : null

  return (
    <AppBar
      elevation={0}
      position="fixed"
      sx={(theme: any) => ({
        ...styles(theme).appBar,
        ...(open ? styles(theme).appBarShift : {}),
        // Light purple tint of the app's primary (#4f5bd5) so the header reads as branded but stays readable.
        backgroundColor: lighten(theme.palette.primary.main, 0.9),
        color: theme.palette.text.primary,
        borderBottom: `1px solid ${theme.palette.divider}`,
      })}>
      <Toolbar disableGutters={!open}>
        {drawer && (
          <Box
            sx={(theme: any) => ({
              display: open ? 'none' : 'flex',
              justifyContent: 'center',
              width: theme.spacing(7),
              [theme.breakpoints.up('sm')]: { width: theme.spacing(9) },
            })}>
            <IconButton aria-label="open drawer" color="inherit" onClick={onDrawerOpen} size="large">
              <MenuIcon />
            </IconButton>
          </Box>
        )}

        <Box
          component={Link}
          to="/"
          sx={(theme: any) => ({
            ...styles(theme).appBarTitle,
            ...(!drawer ? styles(theme).appBarNoDrawer : {}),
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            color: 'inherit',
          })}>
          <img alt="Albacross" src={logo} style={{ height: 26, display: 'block' }} />
          <Typography color="text.secondary" noWrap variant="h6">
            Management
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        {authButton}
      </Toolbar>
    </AppBar>
  )
}

export default withRouter(
  connect((s: RootState) => ({ authenticated: s.auth.authenticated }), { logout })(CoreLayoutHeader),
)
